<app-tableau-iframe-view
  [cFootprintCard]="carboonFootprintCard"
  [cFootprintFFlag]="carbonFootprintFFlag"
  [tableauConfig]="tableauDatabaseToolsConfig"
  [titleName]="titleName"
  [subscriptionName]="subscriptionName"
  (requestAccess)="onClickRequestAccess()"
></app-tableau-iframe-view>
